<template>
    <div id="main">
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('agro-tipoocorrencia') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('agro') }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="$router.push({ name: 'agro-tipoocorrencia-list' })"
                                        >{{ $t('agro-tipoocorrencia') }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id
                                            ? $route.params.id
                                            : $t('novo') + ' ' + $t('agro-tipoocorrencia')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$router.push({ name: 'agro-tipoocorrencia' })"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            class="save-btn"
                            type="button"
                            @click="savetipoocorrencia()"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2 mt-4">
                            <v-input
                                :id="generateId(3)"
                                ref="idagro_tipoocorrenciaerpInput"
                                v-model="tipoocorrencia.idagro_tipoocorrenciaerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                            />
                        </div>
                        <div class="column is-10 mt-4">
                            <v-input
                                :id="generateId(3)"
                                ref="descricaoInput"
                                v-model="tipoocorrencia.descricao"
                                :placeholder="'preencha'"
                                :maxlength="255"
                                :title="'descricao'"
                                :msg="'msg-erro-campo-obrigatorio'"
                                uppercase
                                :invalid="!tipoocorrencia.descricao"
                                :required="true"
                            />
                        </div>
                        <div class="column is-4" style="z-index: 1">
                            <label>{{ $t('icone') }}</label>
                            <b-icon
                                icon="information"
                                size="is-small"
                                v-tippy
                                :title="$t('informacao-tipo-ocorrencia-icone')"
                            />
                            <IconsSelect
                                @changeIcon="changeIcon"
                                ref="iconeInput"
                                :msg="'msg-campo-obrigatorio'"
                                :invalid="!tipoocorrencia.icone"
                                :iconClass="tipoocorrencia.icone"
                                :icons="icones"
                            />
                        </div>
                        <div class="column is-4">
                            <label>{{ $t('pin') }}</label>
                            <b-icon
                                icon="information"
                                size="is-small"
                                v-tippy
                                :title="$t('informacao-tipo-ocorrencia-pin')"
                            />
                            <IconsSelect
                                @changeIcon="changeImage"
                                ref="imageInput"
                                :invalid="!tipoocorrencia.icone"
                                :msg="'msg-campo-obrigatorio'"
                                :iconClass="tipoocorrencia.imagem"
                                :icons="images"
                            />
                        </div>
                        <div class="column is-4">
                            <label for="color">{{ $t('selecione-uma-cor') }}</label>
                            <b-icon
                                icon="information"
                                size="is-small"
                                v-tippy
                                :title="$t('informacao-tipo-ocorrencia-cor')"
                            />
                            <color-picker
                                id="cor"
                                type="text"
                                :color="tipoocorrencia.cor"
                                ref="cpInput"
                                @colorpicked="colorpicked"
                            />
                        </div>
                    </div>
                    <div class="columns is-flex-wrap mt-4"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TipoOcorrenciaService from '@/services/agro/ocorrencia/TipoOcorrenciaService';
import TipoOcorrenciaValidation from '@/services/validations/agro/TipoOcorrenciaValidation';
import ColorPicker from '@/components/shared/form/ColorPicker';
import IconsSelect from '@/components/shared/form/IconsSelect';

export default {
    components: {
        IconsSelect,
        ColorPicker,
    },
    data() {
        return {
            tipoocorrencias: this.$store.state.user.tabelasERPWebServer.includes(
                'agro_tipoocorrencia'
            ),
            service: new TipoOcorrenciaService(this.$http, this.$router),
            isLoading: false,
            isSaving: false,
            codigo: null,
            icones: [
                { pack: 'fas', class: 'feather-alt' },
                { pack: 'fas', class: 'bug' },
                { pack: 'fas', class: 'viruses' },
                { pack: 'fas', class: 'disease' },
                { pack: 'fas', class: 'snowflake' },
                { pack: 'fas', class: 'spa' },
                { pack: 'fas', class: 'wind' },
                { pack: 'fas', class: 'temperature-high' },
                { pack: 'fas', class: 'temperature-low' },
            ],
            images: [
                { pack: 'fas', class: 'feather-alt' },
                { pack: 'fas', class: 'bug' },
                { pack: 'fas', class: 'viruses' },
                { pack: 'fas', class: 'disease' },
                { pack: 'fas', class: 'snowflake' },
                { pack: 'fas', class: 'spa' },
                { pack: 'fas', class: 'wind' },
                { pack: 'fas', class: 'temperature-high' },
                { pack: 'fas', class: 'temperature-low' },
            ],
            invalidIcon: false,
            invalidImage: false,
            tipoocorrencia: {
                idagro_tipoocorrenciaerp: '',
                descricao: '',
                icone: '',
                imagem: '',
                cor: '#D0CFCF',
            },
            validation: null,
            editable: false,
            title: '',
            msgs: [],
            permissao: {},
            isUpdate: false,
            allowedCreate: false,
            allowedUpdate: false,
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },
            checks: {
                obs: { habilita: false, obriga: false },
                nomeContato: { habilita: false, obriga: false },
            },
        };
    },

    created() {
        this.isUpdate = this.$route.params.id != null && this.$route.params.id != 'new';

        this.permissao = this.hasPermissionAccess('agro', 'agro-cadastros', 'agro-tipoocorrencia');

        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'agro-tipoocorrencia' },
            });
        } else {
            if (this.$route.params.id) {
                this.editable = false;
                this.carregarDados();
            }
        }

        if (this.tipoocorrencia != null && this.tipoocorrencia != {}) {
            this.editable = true;
        }

        this.validation = new TipoOcorrenciaValidation(this.msgs);
    },

    methods: {
        changeIcon(icon) {
            this.tipoocorrencia.icone = icon;
        },
        changeImage(image) {
            this.tipoocorrencia.imagem = image;
        },
        colorpicked(color) {
            this.tipoocorrencia.cor = color;
        },
        carregarDados() {
            this.isLoading = true;

            this.service
                .find(this.$route.params.id)
                .then((body) => {
                    if (body.content) {
                        this.tipoocorrencia = body.content;
                    } else {
                        this.$router.push({ name: 'agro-tipoocorrencia-new' });
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        savetipoocorrencia(redirect = this.redirectToList) {
            this.isLoading = true;
            let temptipoocorrencia = Object.assign({}, this.tipoocorrencia);
            temptipoocorrencia = this.mapTosave(temptipoocorrencia);

            if (this.validation.validate(temptipoocorrencia, this.$refs)) {
                this.isSaving = true;

                this.service
                    .save(temptipoocorrencia)
                    .then((res) => {
                        if (res.message == null) {
                            let msg =
                                this.tipoocorrencia.idagro_tipoocorrencia != null
                                    ? 'msg-edit-ocorrencia'
                                    : 'msg-save-ocorrencia';
                            this.$root.showMessage('success', msg);
                            redirect(2);
                        } else {
                            if (this.$t(res.message)) {
                                this.$root.showMessage('alert', 'msg-erro-ocorrencia');
                            } else {
                                this.$root.showMessage('error', 'msg-erro-ocorrencia');
                            }
                        }
                        this.isSaving = false;
                    })
                    .catch((e) => {
                        this.$root.showMessage('error', 'msg-erro-ocorrencia');
                        this.isSaving = false;
                    });
            } else {
                this.$root.showMessage('alert', 'msg-erro-ocorrencia');
                this.isLoading = false;
            }
        },
        redirectToList(time = 1) {
            setTimeout(() => {
                this.$router.push({
                    name: 'agro-tipoocorrencia-list',
                });
            }, time * 1000 + 50);
        },
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
    }
}
</style>
